import { withLayout, withAgentPage } from 'hocs'
import compose from 'recompose/compose'
import MyEventsModule from 'newComponents/MyEvents';


const MyEventsGT = () => {

    return(
        <MyEventsModule />
    )
}

export default compose(
    withLayout, 
    withAgentPage({ fetchTableInfo: true })
)(MyEventsGT);


